export default __webpack_public_path__ + "static/media/reset_password_illustration.6b35fb43.svg";